/* @ngInject */
export default function companyService(Restangular) {
  return Restangular.service('company');
}
